<div class="wrapper">
  @if (attachments() && attachments().length) {
    <div class="toolbar">
      <ng-template [ngTemplateOutlet]="buttonTemplate" />
    </div>
  }

  @if (uploadError) {
    <p class="error" margin-bottom-small>
      {{ errorText }}
    </p>
  }

  <div class="uploading-wrap">
    @for (fileData of filesQueue; track trackByFileData($index)) {
      <rt-uploading-attachments-item [fileData]="fileData" />
    }
  </div>

  <rt-attachments-list
    [attachments]="attachments()"
    [deletable]="canManageFiles"
    [canManageCandidates]="true"
    (deleteClick)="deleteAttachment($event)"
  />
  @if (!attachments().length) {
    <rt-empty-state
      [icon]="'folder-open'"
      [title]="'app.requisitions.files.empty_state.title' | translate"
      [desc]="'app.requisitions.files.empty_state.description' | translate"
      variant="default"
      margin-top-large
    >
      <ng-template [ngTemplateOutlet]="buttonTemplate" />
    </rt-empty-state>
  }
</div>

<ng-template #buttonTemplate>
  @if (canManageFiles) {
    <div class="upload">
      <input
        #fileInput
        (change)="uploadAttachment(fileInput.files, fileInput)"
        type="file"
        hidden
      />
      <rt-button variant="tertiary" [loading]="uploading" (click)="fileInput.click()">
        <rt-icon name="file-upload" />
        <span>{{ 'app.offer_attachments.upload_file' | translate }}</span>
      </rt-button>
    </div>
  }
</ng-template>
